/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Api
 * API specification for Travis Johnson personal website
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AiOutput,
  AiOutputRequest,
  AiOutputUpdate,
  CacSuggestion,
  ContactInput,
  ContactResponse,
  Decision,
  DecisionInput,
  DecisionUpdate,
  DeleteResponse,
  ErrorResponse,
  FieldSuggestionRequest,
  HealthStatus,
  Launch,
  LaunchFinancials,
  LaunchFinancialsUpdate,
  LaunchInput,
  LaunchUpdate,
  LaunchosAuthResponse,
  LaunchosLoginInput,
  LaunchosOverview,
  Milestone,
  MilestoneInput,
  MilestoneUpdate,
  PricingModel,
  PricingModelInput,
  PricingModelUpdate,
  ReadinessItem,
  ReadinessItemUpdate,
  Risk,
  RiskInput,
  RiskUpdate
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getSubmitContactUrl = () => {




  return `/api/contact`
}

/**
 * Sends a contact form message
 * @summary Submit contact form
 */
export const submitContact = async (contactInput: ContactInput, options?: RequestInit): Promise<ContactResponse> => {

  return customFetch<ContactResponse>(getSubmitContactUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(contactInput)
  }
);}





export const getSubmitContactMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitContact>>, TError,{data: BodyType<ContactInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof submitContact>>, TError,{data: BodyType<ContactInput>}, TContext> => {

const mutationKey = ['submitContact'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitContact>>, {data: BodyType<ContactInput>}> = (props) => {
          const {data} = props ?? {};

          return  submitContact(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SubmitContactMutationResult = NonNullable<Awaited<ReturnType<typeof submitContact>>>
    export type SubmitContactMutationBody = BodyType<ContactInput>
    export type SubmitContactMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Submit contact form
 */
export const useSubmitContact = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitContact>>, TError,{data: BodyType<ContactInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof submitContact>>,
        TError,
        {data: BodyType<ContactInput>},
        TContext
      > => {
      return useMutation(getSubmitContactMutationOptions(options));
    }

export const getLaunchosLoginUrl = () => {




  return `/api/launchos/auth/login`
}

/**
 * @summary Login to LaunchOS
 */
export const launchosLogin = async (launchosLoginInput: LaunchosLoginInput, options?: RequestInit): Promise<LaunchosAuthResponse> => {

  return customFetch<LaunchosAuthResponse>(getLaunchosLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(launchosLoginInput)
  }
);}





export const getLaunchosLoginMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof launchosLogin>>, TError,{data: BodyType<LaunchosLoginInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof launchosLogin>>, TError,{data: BodyType<LaunchosLoginInput>}, TContext> => {

const mutationKey = ['launchosLogin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof launchosLogin>>, {data: BodyType<LaunchosLoginInput>}> = (props) => {
          const {data} = props ?? {};

          return  launchosLogin(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LaunchosLoginMutationResult = NonNullable<Awaited<ReturnType<typeof launchosLogin>>>
    export type LaunchosLoginMutationBody = BodyType<LaunchosLoginInput>
    export type LaunchosLoginMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Login to LaunchOS
 */
export const useLaunchosLogin = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof launchosLogin>>, TError,{data: BodyType<LaunchosLoginInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof launchosLogin>>,
        TError,
        {data: BodyType<LaunchosLoginInput>},
        TContext
      > => {
      return useMutation(getLaunchosLoginMutationOptions(options));
    }

export const getLaunchosLogoutUrl = () => {




  return `/api/launchos/auth/logout`
}

/**
 * @summary Logout from LaunchOS
 */
export const launchosLogout = async ( options?: RequestInit): Promise<LaunchosAuthResponse> => {

  return customFetch<LaunchosAuthResponse>(getLaunchosLogoutUrl(),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLaunchosLogoutMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof launchosLogout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof launchosLogout>>, TError,void, TContext> => {

const mutationKey = ['launchosLogout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof launchosLogout>>, void> = () => {


          return  launchosLogout(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LaunchosLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof launchosLogout>>>

    export type LaunchosLogoutMutationError = ErrorType<unknown>

    /**
 * @summary Logout from LaunchOS
 */
export const useLaunchosLogout = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof launchosLogout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof launchosLogout>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLaunchosLogoutMutationOptions(options));
    }

export const getLaunchosGetMeUrl = () => {




  return `/api/launchos/auth/me`
}

/**
 * @summary Get current session info
 */
export const launchosGetMe = async ( options?: RequestInit): Promise<LaunchosAuthResponse> => {

  return customFetch<LaunchosAuthResponse>(getLaunchosGetMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLaunchosGetMeQueryKey = () => {
    return [
    `/api/launchos/auth/me`
    ] as const;
    }


export const getLaunchosGetMeQueryOptions = <TData = Awaited<ReturnType<typeof launchosGetMe>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof launchosGetMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLaunchosGetMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof launchosGetMe>>> = ({ signal }) => launchosGetMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof launchosGetMe>>, TError, TData> & { queryKey: QueryKey }
}

export type LaunchosGetMeQueryResult = NonNullable<Awaited<ReturnType<typeof launchosGetMe>>>
export type LaunchosGetMeQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get current session info
 */

export function useLaunchosGetMe<TData = Awaited<ReturnType<typeof launchosGetMe>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof launchosGetMe>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getLaunchosGetMeQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetLaunchosOverviewUrl = () => {




  return `/api/launchos/overview`
}

/**
 * Aggregated stats across all launches
 * @summary Portfolio overview metrics
 */
export const getLaunchosOverview = async ( options?: RequestInit): Promise<LaunchosOverview> => {

  return customFetch<LaunchosOverview>(getGetLaunchosOverviewUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLaunchosOverviewQueryKey = () => {
    return [
    `/api/launchos/overview`
    ] as const;
    }


export const getGetLaunchosOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getLaunchosOverview>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLaunchosOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLaunchosOverviewQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLaunchosOverview>>> = ({ signal }) => getLaunchosOverview({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLaunchosOverview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLaunchosOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getLaunchosOverview>>>
export type GetLaunchosOverviewQueryError = ErrorType<ErrorResponse>


/**
 * @summary Portfolio overview metrics
 */

export function useGetLaunchosOverview<TData = Awaited<ReturnType<typeof getLaunchosOverview>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLaunchosOverview>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLaunchosOverviewQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getListLaunchesUrl = () => {




  return `/api/launchos/launches`
}

/**
 * @summary List all launches
 */
export const listLaunches = async ( options?: RequestInit): Promise<Launch[]> => {

  return customFetch<Launch[]>(getListLaunchesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLaunchesQueryKey = () => {
    return [
    `/api/launchos/launches`
    ] as const;
    }


export const getListLaunchesQueryOptions = <TData = Awaited<ReturnType<typeof listLaunches>>, TError = ErrorType<ErrorResponse>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLaunches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLaunchesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLaunches>>> = ({ signal }) => listLaunches({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLaunches>>, TError, TData> & { queryKey: QueryKey }
}

export type ListLaunchesQueryResult = NonNullable<Awaited<ReturnType<typeof listLaunches>>>
export type ListLaunchesQueryError = ErrorType<ErrorResponse>


/**
 * @summary List all launches
 */

export function useListLaunches<TData = Awaited<ReturnType<typeof listLaunches>>, TError = ErrorType<ErrorResponse>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLaunches>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListLaunchesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateLaunchUrl = () => {




  return `/api/launchos/launches`
}

/**
 * @summary Create a new launch
 */
export const createLaunch = async (launchInput: LaunchInput, options?: RequestInit): Promise<Launch> => {

  return customFetch<Launch>(getCreateLaunchUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(launchInput)
  }
);}





export const getCreateLaunchMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLaunch>>, TError,{data: BodyType<LaunchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLaunch>>, TError,{data: BodyType<LaunchInput>}, TContext> => {

const mutationKey = ['createLaunch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLaunch>>, {data: BodyType<LaunchInput>}> = (props) => {
          const {data} = props ?? {};

          return  createLaunch(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLaunchMutationResult = NonNullable<Awaited<ReturnType<typeof createLaunch>>>
    export type CreateLaunchMutationBody = BodyType<LaunchInput>
    export type CreateLaunchMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Create a new launch
 */
export const useCreateLaunch = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLaunch>>, TError,{data: BodyType<LaunchInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createLaunch>>,
        TError,
        {data: BodyType<LaunchInput>},
        TContext
      > => {
      return useMutation(getCreateLaunchMutationOptions(options));
    }

export const getGetLaunchUrl = (launchId: number,) => {




  return `/api/launchos/launches/${launchId}`
}

/**
 * @summary Get a single launch
 */
export const getLaunch = async (launchId: number, options?: RequestInit): Promise<Launch> => {

  return customFetch<Launch>(getGetLaunchUrl(launchId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLaunchQueryKey = (launchId: number,) => {
    return [
    `/api/launchos/launches/${launchId}`
    ] as const;
    }


export const getGetLaunchQueryOptions = <TData = Awaited<ReturnType<typeof getLaunch>>, TError = ErrorType<ErrorResponse>>(launchId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLaunch>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLaunchQueryKey(launchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLaunch>>> = ({ signal }) => getLaunch(launchId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: launchId !== null && launchId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLaunch>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLaunchQueryResult = NonNullable<Awaited<ReturnType<typeof getLaunch>>>
export type GetLaunchQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a single launch
 */

export function useGetLaunch<TData = Awaited<ReturnType<typeof getLaunch>>, TError = ErrorType<ErrorResponse>>(
 launchId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLaunch>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLaunchQueryOptions(launchId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateLaunchUrl = (launchId: number,) => {




  return `/api/launchos/launches/${launchId}`
}

/**
 * @summary Update a launch
 */
export const updateLaunch = async (launchId: number,
    launchUpdate: LaunchUpdate, options?: RequestInit): Promise<Launch> => {

  return customFetch<Launch>(getUpdateLaunchUrl(launchId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(launchUpdate)
  }
);}





export const getUpdateLaunchMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLaunch>>, TError,{launchId: number;data: BodyType<LaunchUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLaunch>>, TError,{launchId: number;data: BodyType<LaunchUpdate>}, TContext> => {

const mutationKey = ['updateLaunch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLaunch>>, {launchId: number;data: BodyType<LaunchUpdate>}> = (props) => {
          const {launchId,data} = props ?? {};

          return  updateLaunch(launchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLaunchMutationResult = NonNullable<Awaited<ReturnType<typeof updateLaunch>>>
    export type UpdateLaunchMutationBody = BodyType<LaunchUpdate>
    export type UpdateLaunchMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update a launch
 */
export const useUpdateLaunch = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLaunch>>, TError,{launchId: number;data: BodyType<LaunchUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateLaunch>>,
        TError,
        {launchId: number;data: BodyType<LaunchUpdate>},
        TContext
      > => {
      return useMutation(getUpdateLaunchMutationOptions(options));
    }

export const getDeleteLaunchUrl = (launchId: number,) => {




  return `/api/launchos/launches/${launchId}`
}

/**
 * @summary Delete a launch
 */
export const deleteLaunch = async (launchId: number, options?: RequestInit): Promise<DeleteResponse> => {

  return customFetch<DeleteResponse>(getDeleteLaunchUrl(launchId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteLaunchMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLaunch>>, TError,{launchId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLaunch>>, TError,{launchId: number}, TContext> => {

const mutationKey = ['deleteLaunch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLaunch>>, {launchId: number}> = (props) => {
          const {launchId} = props ?? {};

          return  deleteLaunch(launchId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLaunchMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLaunch>>>

    export type DeleteLaunchMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete a launch
 */
export const useDeleteLaunch = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLaunch>>, TError,{launchId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteLaunch>>,
        TError,
        {launchId: number},
        TContext
      > => {
      return useMutation(getDeleteLaunchMutationOptions(options));
    }

export const getGetLaunchFinancialsUrl = (launchId: number,) => {




  return `/api/launchos/launches/${launchId}/financials`
}

/**
 * @summary Get financial assumptions for a launch
 */
export const getLaunchFinancials = async (launchId: number, options?: RequestInit): Promise<LaunchFinancials> => {

  return customFetch<LaunchFinancials>(getGetLaunchFinancialsUrl(launchId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLaunchFinancialsQueryKey = (launchId: number,) => {
    return [
    `/api/launchos/launches/${launchId}/financials`
    ] as const;
    }


export const getGetLaunchFinancialsQueryOptions = <TData = Awaited<ReturnType<typeof getLaunchFinancials>>, TError = ErrorType<ErrorResponse>>(launchId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLaunchFinancials>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLaunchFinancialsQueryKey(launchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLaunchFinancials>>> = ({ signal }) => getLaunchFinancials(launchId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: launchId !== null && launchId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLaunchFinancials>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLaunchFinancialsQueryResult = NonNullable<Awaited<ReturnType<typeof getLaunchFinancials>>>
export type GetLaunchFinancialsQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get financial assumptions for a launch
 */

export function useGetLaunchFinancials<TData = Awaited<ReturnType<typeof getLaunchFinancials>>, TError = ErrorType<ErrorResponse>>(
 launchId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLaunchFinancials>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLaunchFinancialsQueryOptions(launchId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateLaunchFinancialsUrl = (launchId: number,) => {




  return `/api/launchos/launches/${launchId}/financials`
}

/**
 * @summary Update financial assumptions
 */
export const updateLaunchFinancials = async (launchId: number,
    launchFinancialsUpdate: LaunchFinancialsUpdate, options?: RequestInit): Promise<LaunchFinancials> => {

  return customFetch<LaunchFinancials>(getUpdateLaunchFinancialsUrl(launchId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(launchFinancialsUpdate)
  }
);}





export const getUpdateLaunchFinancialsMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLaunchFinancials>>, TError,{launchId: number;data: BodyType<LaunchFinancialsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLaunchFinancials>>, TError,{launchId: number;data: BodyType<LaunchFinancialsUpdate>}, TContext> => {

const mutationKey = ['updateLaunchFinancials'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLaunchFinancials>>, {launchId: number;data: BodyType<LaunchFinancialsUpdate>}> = (props) => {
          const {launchId,data} = props ?? {};

          return  updateLaunchFinancials(launchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLaunchFinancialsMutationResult = NonNullable<Awaited<ReturnType<typeof updateLaunchFinancials>>>
    export type UpdateLaunchFinancialsMutationBody = BodyType<LaunchFinancialsUpdate>
    export type UpdateLaunchFinancialsMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update financial assumptions
 */
export const useUpdateLaunchFinancials = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLaunchFinancials>>, TError,{launchId: number;data: BodyType<LaunchFinancialsUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateLaunchFinancials>>,
        TError,
        {launchId: number;data: BodyType<LaunchFinancialsUpdate>},
        TContext
      > => {
      return useMutation(getUpdateLaunchFinancialsMutationOptions(options));
    }

export const getListPricingModelsUrl = (launchId: number,) => {




  return `/api/launchos/launches/${launchId}/pricing-models`
}

/**
 * @summary List pricing models for a launch
 */
export const listPricingModels = async (launchId: number, options?: RequestInit): Promise<PricingModel[]> => {

  return customFetch<PricingModel[]>(getListPricingModelsUrl(launchId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPricingModelsQueryKey = (launchId: number,) => {
    return [
    `/api/launchos/launches/${launchId}/pricing-models`
    ] as const;
    }


export const getListPricingModelsQueryOptions = <TData = Awaited<ReturnType<typeof listPricingModels>>, TError = ErrorType<ErrorResponse>>(launchId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingModels>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPricingModelsQueryKey(launchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPricingModels>>> = ({ signal }) => listPricingModels(launchId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: launchId !== null && launchId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPricingModels>>, TError, TData> & { queryKey: QueryKey }
}

export type ListPricingModelsQueryResult = NonNullable<Awaited<ReturnType<typeof listPricingModels>>>
export type ListPricingModelsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List pricing models for a launch
 */

export function useListPricingModels<TData = Awaited<ReturnType<typeof listPricingModels>>, TError = ErrorType<ErrorResponse>>(
 launchId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listPricingModels>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListPricingModelsQueryOptions(launchId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreatePricingModelUrl = (launchId: number,) => {




  return `/api/launchos/launches/${launchId}/pricing-models`
}

/**
 * @summary Create a pricing model
 */
export const createPricingModel = async (launchId: number,
    pricingModelInput: PricingModelInput, options?: RequestInit): Promise<PricingModel> => {

  return customFetch<PricingModel>(getCreatePricingModelUrl(launchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pricingModelInput)
  }
);}





export const getCreatePricingModelMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPricingModel>>, TError,{launchId: number;data: BodyType<PricingModelInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createPricingModel>>, TError,{launchId: number;data: BodyType<PricingModelInput>}, TContext> => {

const mutationKey = ['createPricingModel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPricingModel>>, {launchId: number;data: BodyType<PricingModelInput>}> = (props) => {
          const {launchId,data} = props ?? {};

          return  createPricingModel(launchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePricingModelMutationResult = NonNullable<Awaited<ReturnType<typeof createPricingModel>>>
    export type CreatePricingModelMutationBody = BodyType<PricingModelInput>
    export type CreatePricingModelMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Create a pricing model
 */
export const useCreatePricingModel = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPricingModel>>, TError,{launchId: number;data: BodyType<PricingModelInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createPricingModel>>,
        TError,
        {launchId: number;data: BodyType<PricingModelInput>},
        TContext
      > => {
      return useMutation(getCreatePricingModelMutationOptions(options));
    }

export const getUpdatePricingModelUrl = (launchId: number,
    modelId: number,) => {




  return `/api/launchos/launches/${launchId}/pricing-models/${modelId}`
}

/**
 * @summary Update a pricing model
 */
export const updatePricingModel = async (launchId: number,
    modelId: number,
    pricingModelUpdate: PricingModelUpdate, options?: RequestInit): Promise<PricingModel> => {

  return customFetch<PricingModel>(getUpdatePricingModelUrl(launchId,modelId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(pricingModelUpdate)
  }
);}





export const getUpdatePricingModelMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePricingModel>>, TError,{launchId: number;modelId: number;data: BodyType<PricingModelUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePricingModel>>, TError,{launchId: number;modelId: number;data: BodyType<PricingModelUpdate>}, TContext> => {

const mutationKey = ['updatePricingModel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePricingModel>>, {launchId: number;modelId: number;data: BodyType<PricingModelUpdate>}> = (props) => {
          const {launchId,modelId,data} = props ?? {};

          return  updatePricingModel(launchId,modelId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePricingModelMutationResult = NonNullable<Awaited<ReturnType<typeof updatePricingModel>>>
    export type UpdatePricingModelMutationBody = BodyType<PricingModelUpdate>
    export type UpdatePricingModelMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update a pricing model
 */
export const useUpdatePricingModel = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePricingModel>>, TError,{launchId: number;modelId: number;data: BodyType<PricingModelUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePricingModel>>,
        TError,
        {launchId: number;modelId: number;data: BodyType<PricingModelUpdate>},
        TContext
      > => {
      return useMutation(getUpdatePricingModelMutationOptions(options));
    }

export const getDeletePricingModelUrl = (launchId: number,
    modelId: number,) => {




  return `/api/launchos/launches/${launchId}/pricing-models/${modelId}`
}

/**
 * @summary Delete a pricing model
 */
export const deletePricingModel = async (launchId: number,
    modelId: number, options?: RequestInit): Promise<DeleteResponse> => {

  return customFetch<DeleteResponse>(getDeletePricingModelUrl(launchId,modelId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePricingModelMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePricingModel>>, TError,{launchId: number;modelId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePricingModel>>, TError,{launchId: number;modelId: number}, TContext> => {

const mutationKey = ['deletePricingModel'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePricingModel>>, {launchId: number;modelId: number}> = (props) => {
          const {launchId,modelId} = props ?? {};

          return  deletePricingModel(launchId,modelId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePricingModelMutationResult = NonNullable<Awaited<ReturnType<typeof deletePricingModel>>>

    export type DeletePricingModelMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete a pricing model
 */
export const useDeletePricingModel = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePricingModel>>, TError,{launchId: number;modelId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deletePricingModel>>,
        TError,
        {launchId: number;modelId: number},
        TContext
      > => {
      return useMutation(getDeletePricingModelMutationOptions(options));
    }

export const getSuggestCacUrl = (launchId: number,) => {




  return `/api/launchos/launches/${launchId}/cac-suggestion`
}

/**
 * Uses AI with the launch's product, market, pricing, and budget context to suggest a CAC range.
 * @summary AI-suggested CAC for a launch
 */
export const suggestCac = async (launchId: number, options?: RequestInit): Promise<CacSuggestion> => {

  return customFetch<CacSuggestion>(getSuggestCacUrl(launchId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getSuggestCacMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suggestCac>>, TError,{launchId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof suggestCac>>, TError,{launchId: number}, TContext> => {

const mutationKey = ['suggestCac'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof suggestCac>>, {launchId: number}> = (props) => {
          const {launchId} = props ?? {};

          return  suggestCac(launchId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SuggestCacMutationResult = NonNullable<Awaited<ReturnType<typeof suggestCac>>>

    export type SuggestCacMutationError = ErrorType<ErrorResponse>

    /**
 * @summary AI-suggested CAC for a launch
 */
export const useSuggestCac = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suggestCac>>, TError,{launchId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof suggestCac>>,
        TError,
        {launchId: number},
        TContext
      > => {
      return useMutation(getSuggestCacMutationOptions(options));
    }

export const getSuggestFieldUrl = (launchId: number,) => {




  return `/api/launchos/launches/${launchId}/field-suggestion`
}

/**
 * Uses AI with the launch's product, market, pricing, and channel context to suggest a low/high/point estimate for a specific financial field, with a benchmark-grounded rationale.
 * @summary AI-suggested value for a financial assumption field
 */
export const suggestField = async (launchId: number,
    fieldSuggestionRequest: FieldSuggestionRequest, options?: RequestInit): Promise<CacSuggestion> => {

  return customFetch<CacSuggestion>(getSuggestFieldUrl(launchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(fieldSuggestionRequest)
  }
);}





export const getSuggestFieldMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suggestField>>, TError,{launchId: number;data: BodyType<FieldSuggestionRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof suggestField>>, TError,{launchId: number;data: BodyType<FieldSuggestionRequest>}, TContext> => {

const mutationKey = ['suggestField'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof suggestField>>, {launchId: number;data: BodyType<FieldSuggestionRequest>}> = (props) => {
          const {launchId,data} = props ?? {};

          return  suggestField(launchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SuggestFieldMutationResult = NonNullable<Awaited<ReturnType<typeof suggestField>>>
    export type SuggestFieldMutationBody = BodyType<FieldSuggestionRequest>
    export type SuggestFieldMutationError = ErrorType<ErrorResponse>

    /**
 * @summary AI-suggested value for a financial assumption field
 */
export const useSuggestField = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof suggestField>>, TError,{launchId: number;data: BodyType<FieldSuggestionRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof suggestField>>,
        TError,
        {launchId: number;data: BodyType<FieldSuggestionRequest>},
        TContext
      > => {
      return useMutation(getSuggestFieldMutationOptions(options));
    }

export const getGetLaunchReadinessUrl = (launchId: number,) => {




  return `/api/launchos/launches/${launchId}/readiness`
}

/**
 * @summary Get readiness scorecard for a launch
 */
export const getLaunchReadiness = async (launchId: number, options?: RequestInit): Promise<ReadinessItem[]> => {

  return customFetch<ReadinessItem[]>(getGetLaunchReadinessUrl(launchId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetLaunchReadinessQueryKey = (launchId: number,) => {
    return [
    `/api/launchos/launches/${launchId}/readiness`
    ] as const;
    }


export const getGetLaunchReadinessQueryOptions = <TData = Awaited<ReturnType<typeof getLaunchReadiness>>, TError = ErrorType<ErrorResponse>>(launchId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLaunchReadiness>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLaunchReadinessQueryKey(launchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLaunchReadiness>>> = ({ signal }) => getLaunchReadiness(launchId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: launchId !== null && launchId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLaunchReadiness>>, TError, TData> & { queryKey: QueryKey }
}

export type GetLaunchReadinessQueryResult = NonNullable<Awaited<ReturnType<typeof getLaunchReadiness>>>
export type GetLaunchReadinessQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get readiness scorecard for a launch
 */

export function useGetLaunchReadiness<TData = Awaited<ReturnType<typeof getLaunchReadiness>>, TError = ErrorType<ErrorResponse>>(
 launchId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getLaunchReadiness>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetLaunchReadinessQueryOptions(launchId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateReadinessItemUrl = (launchId: number,
    itemId: number,) => {




  return `/api/launchos/launches/${launchId}/readiness/${itemId}`
}

/**
 * @summary Update a readiness scorecard item
 */
export const updateReadinessItem = async (launchId: number,
    itemId: number,
    readinessItemUpdate: ReadinessItemUpdate, options?: RequestInit): Promise<ReadinessItem> => {

  return customFetch<ReadinessItem>(getUpdateReadinessItemUrl(launchId,itemId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(readinessItemUpdate)
  }
);}





export const getUpdateReadinessItemMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReadinessItem>>, TError,{launchId: number;itemId: number;data: BodyType<ReadinessItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateReadinessItem>>, TError,{launchId: number;itemId: number;data: BodyType<ReadinessItemUpdate>}, TContext> => {

const mutationKey = ['updateReadinessItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateReadinessItem>>, {launchId: number;itemId: number;data: BodyType<ReadinessItemUpdate>}> = (props) => {
          const {launchId,itemId,data} = props ?? {};

          return  updateReadinessItem(launchId,itemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateReadinessItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateReadinessItem>>>
    export type UpdateReadinessItemMutationBody = BodyType<ReadinessItemUpdate>
    export type UpdateReadinessItemMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update a readiness scorecard item
 */
export const useUpdateReadinessItem = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReadinessItem>>, TError,{launchId: number;itemId: number;data: BodyType<ReadinessItemUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateReadinessItem>>,
        TError,
        {launchId: number;itemId: number;data: BodyType<ReadinessItemUpdate>},
        TContext
      > => {
      return useMutation(getUpdateReadinessItemMutationOptions(options));
    }

export const getListRisksUrl = (launchId: number,) => {




  return `/api/launchos/launches/${launchId}/risks`
}

/**
 * @summary List risks for a launch
 */
export const listRisks = async (launchId: number, options?: RequestInit): Promise<Risk[]> => {

  return customFetch<Risk[]>(getListRisksUrl(launchId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRisksQueryKey = (launchId: number,) => {
    return [
    `/api/launchos/launches/${launchId}/risks`
    ] as const;
    }


export const getListRisksQueryOptions = <TData = Awaited<ReturnType<typeof listRisks>>, TError = ErrorType<ErrorResponse>>(launchId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRisks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRisksQueryKey(launchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRisks>>> = ({ signal }) => listRisks(launchId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: launchId !== null && launchId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRisks>>, TError, TData> & { queryKey: QueryKey }
}

export type ListRisksQueryResult = NonNullable<Awaited<ReturnType<typeof listRisks>>>
export type ListRisksQueryError = ErrorType<ErrorResponse>


/**
 * @summary List risks for a launch
 */

export function useListRisks<TData = Awaited<ReturnType<typeof listRisks>>, TError = ErrorType<ErrorResponse>>(
 launchId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listRisks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListRisksQueryOptions(launchId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateRiskUrl = (launchId: number,) => {




  return `/api/launchos/launches/${launchId}/risks`
}

/**
 * @summary Create a risk
 */
export const createRisk = async (launchId: number,
    riskInput: RiskInput, options?: RequestInit): Promise<Risk> => {

  return customFetch<Risk>(getCreateRiskUrl(launchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(riskInput)
  }
);}





export const getCreateRiskMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRisk>>, TError,{launchId: number;data: BodyType<RiskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createRisk>>, TError,{launchId: number;data: BodyType<RiskInput>}, TContext> => {

const mutationKey = ['createRisk'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRisk>>, {launchId: number;data: BodyType<RiskInput>}> = (props) => {
          const {launchId,data} = props ?? {};

          return  createRisk(launchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRiskMutationResult = NonNullable<Awaited<ReturnType<typeof createRisk>>>
    export type CreateRiskMutationBody = BodyType<RiskInput>
    export type CreateRiskMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Create a risk
 */
export const useCreateRisk = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRisk>>, TError,{launchId: number;data: BodyType<RiskInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createRisk>>,
        TError,
        {launchId: number;data: BodyType<RiskInput>},
        TContext
      > => {
      return useMutation(getCreateRiskMutationOptions(options));
    }

export const getUpdateRiskUrl = (launchId: number,
    riskId: number,) => {




  return `/api/launchos/launches/${launchId}/risks/${riskId}`
}

/**
 * @summary Update a risk
 */
export const updateRisk = async (launchId: number,
    riskId: number,
    riskUpdate: RiskUpdate, options?: RequestInit): Promise<Risk> => {

  return customFetch<Risk>(getUpdateRiskUrl(launchId,riskId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(riskUpdate)
  }
);}





export const getUpdateRiskMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRisk>>, TError,{launchId: number;riskId: number;data: BodyType<RiskUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateRisk>>, TError,{launchId: number;riskId: number;data: BodyType<RiskUpdate>}, TContext> => {

const mutationKey = ['updateRisk'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateRisk>>, {launchId: number;riskId: number;data: BodyType<RiskUpdate>}> = (props) => {
          const {launchId,riskId,data} = props ?? {};

          return  updateRisk(launchId,riskId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateRiskMutationResult = NonNullable<Awaited<ReturnType<typeof updateRisk>>>
    export type UpdateRiskMutationBody = BodyType<RiskUpdate>
    export type UpdateRiskMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update a risk
 */
export const useUpdateRisk = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateRisk>>, TError,{launchId: number;riskId: number;data: BodyType<RiskUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateRisk>>,
        TError,
        {launchId: number;riskId: number;data: BodyType<RiskUpdate>},
        TContext
      > => {
      return useMutation(getUpdateRiskMutationOptions(options));
    }

export const getDeleteRiskUrl = (launchId: number,
    riskId: number,) => {




  return `/api/launchos/launches/${launchId}/risks/${riskId}`
}

/**
 * @summary Delete a risk
 */
export const deleteRisk = async (launchId: number,
    riskId: number, options?: RequestInit): Promise<DeleteResponse> => {

  return customFetch<DeleteResponse>(getDeleteRiskUrl(launchId,riskId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteRiskMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRisk>>, TError,{launchId: number;riskId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteRisk>>, TError,{launchId: number;riskId: number}, TContext> => {

const mutationKey = ['deleteRisk'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteRisk>>, {launchId: number;riskId: number}> = (props) => {
          const {launchId,riskId} = props ?? {};

          return  deleteRisk(launchId,riskId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteRiskMutationResult = NonNullable<Awaited<ReturnType<typeof deleteRisk>>>

    export type DeleteRiskMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete a risk
 */
export const useDeleteRisk = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteRisk>>, TError,{launchId: number;riskId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteRisk>>,
        TError,
        {launchId: number;riskId: number},
        TContext
      > => {
      return useMutation(getDeleteRiskMutationOptions(options));
    }

export const getListDecisionsUrl = (launchId: number,) => {




  return `/api/launchos/launches/${launchId}/decisions`
}

/**
 * @summary List decisions for a launch
 */
export const listDecisions = async (launchId: number, options?: RequestInit): Promise<Decision[]> => {

  return customFetch<Decision[]>(getListDecisionsUrl(launchId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDecisionsQueryKey = (launchId: number,) => {
    return [
    `/api/launchos/launches/${launchId}/decisions`
    ] as const;
    }


export const getListDecisionsQueryOptions = <TData = Awaited<ReturnType<typeof listDecisions>>, TError = ErrorType<ErrorResponse>>(launchId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDecisions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDecisionsQueryKey(launchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDecisions>>> = ({ signal }) => listDecisions(launchId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: launchId !== null && launchId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDecisions>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDecisionsQueryResult = NonNullable<Awaited<ReturnType<typeof listDecisions>>>
export type ListDecisionsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List decisions for a launch
 */

export function useListDecisions<TData = Awaited<ReturnType<typeof listDecisions>>, TError = ErrorType<ErrorResponse>>(
 launchId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDecisions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDecisionsQueryOptions(launchId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateDecisionUrl = (launchId: number,) => {




  return `/api/launchos/launches/${launchId}/decisions`
}

/**
 * @summary Create a decision
 */
export const createDecision = async (launchId: number,
    decisionInput: DecisionInput, options?: RequestInit): Promise<Decision> => {

  return customFetch<Decision>(getCreateDecisionUrl(launchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(decisionInput)
  }
);}





export const getCreateDecisionMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDecision>>, TError,{launchId: number;data: BodyType<DecisionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDecision>>, TError,{launchId: number;data: BodyType<DecisionInput>}, TContext> => {

const mutationKey = ['createDecision'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDecision>>, {launchId: number;data: BodyType<DecisionInput>}> = (props) => {
          const {launchId,data} = props ?? {};

          return  createDecision(launchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDecisionMutationResult = NonNullable<Awaited<ReturnType<typeof createDecision>>>
    export type CreateDecisionMutationBody = BodyType<DecisionInput>
    export type CreateDecisionMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Create a decision
 */
export const useCreateDecision = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDecision>>, TError,{launchId: number;data: BodyType<DecisionInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDecision>>,
        TError,
        {launchId: number;data: BodyType<DecisionInput>},
        TContext
      > => {
      return useMutation(getCreateDecisionMutationOptions(options));
    }

export const getUpdateDecisionUrl = (launchId: number,
    decisionId: number,) => {




  return `/api/launchos/launches/${launchId}/decisions/${decisionId}`
}

/**
 * @summary Update a decision
 */
export const updateDecision = async (launchId: number,
    decisionId: number,
    decisionUpdate: DecisionUpdate, options?: RequestInit): Promise<Decision> => {

  return customFetch<Decision>(getUpdateDecisionUrl(launchId,decisionId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(decisionUpdate)
  }
);}





export const getUpdateDecisionMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDecision>>, TError,{launchId: number;decisionId: number;data: BodyType<DecisionUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateDecision>>, TError,{launchId: number;decisionId: number;data: BodyType<DecisionUpdate>}, TContext> => {

const mutationKey = ['updateDecision'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateDecision>>, {launchId: number;decisionId: number;data: BodyType<DecisionUpdate>}> = (props) => {
          const {launchId,decisionId,data} = props ?? {};

          return  updateDecision(launchId,decisionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateDecisionMutationResult = NonNullable<Awaited<ReturnType<typeof updateDecision>>>
    export type UpdateDecisionMutationBody = BodyType<DecisionUpdate>
    export type UpdateDecisionMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update a decision
 */
export const useUpdateDecision = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateDecision>>, TError,{launchId: number;decisionId: number;data: BodyType<DecisionUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateDecision>>,
        TError,
        {launchId: number;decisionId: number;data: BodyType<DecisionUpdate>},
        TContext
      > => {
      return useMutation(getUpdateDecisionMutationOptions(options));
    }

export const getDeleteDecisionUrl = (launchId: number,
    decisionId: number,) => {




  return `/api/launchos/launches/${launchId}/decisions/${decisionId}`
}

/**
 * @summary Delete a decision
 */
export const deleteDecision = async (launchId: number,
    decisionId: number, options?: RequestInit): Promise<DeleteResponse> => {

  return customFetch<DeleteResponse>(getDeleteDecisionUrl(launchId,decisionId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteDecisionMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDecision>>, TError,{launchId: number;decisionId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDecision>>, TError,{launchId: number;decisionId: number}, TContext> => {

const mutationKey = ['deleteDecision'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDecision>>, {launchId: number;decisionId: number}> = (props) => {
          const {launchId,decisionId} = props ?? {};

          return  deleteDecision(launchId,decisionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDecisionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDecision>>>

    export type DeleteDecisionMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete a decision
 */
export const useDeleteDecision = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDecision>>, TError,{launchId: number;decisionId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteDecision>>,
        TError,
        {launchId: number;decisionId: number},
        TContext
      > => {
      return useMutation(getDeleteDecisionMutationOptions(options));
    }

export const getListMilestonesUrl = (launchId: number,) => {




  return `/api/launchos/launches/${launchId}/milestones`
}

/**
 * @summary List milestones for a launch
 */
export const listMilestones = async (launchId: number, options?: RequestInit): Promise<Milestone[]> => {

  return customFetch<Milestone[]>(getListMilestonesUrl(launchId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListMilestonesQueryKey = (launchId: number,) => {
    return [
    `/api/launchos/launches/${launchId}/milestones`
    ] as const;
    }


export const getListMilestonesQueryOptions = <TData = Awaited<ReturnType<typeof listMilestones>>, TError = ErrorType<ErrorResponse>>(launchId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMilestones>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListMilestonesQueryKey(launchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listMilestones>>> = ({ signal }) => listMilestones(launchId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: launchId !== null && launchId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listMilestones>>, TError, TData> & { queryKey: QueryKey }
}

export type ListMilestonesQueryResult = NonNullable<Awaited<ReturnType<typeof listMilestones>>>
export type ListMilestonesQueryError = ErrorType<ErrorResponse>


/**
 * @summary List milestones for a launch
 */

export function useListMilestones<TData = Awaited<ReturnType<typeof listMilestones>>, TError = ErrorType<ErrorResponse>>(
 launchId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listMilestones>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListMilestonesQueryOptions(launchId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateMilestoneUrl = (launchId: number,) => {




  return `/api/launchos/launches/${launchId}/milestones`
}

/**
 * @summary Create a milestone
 */
export const createMilestone = async (launchId: number,
    milestoneInput: MilestoneInput, options?: RequestInit): Promise<Milestone> => {

  return customFetch<Milestone>(getCreateMilestoneUrl(launchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(milestoneInput)
  }
);}





export const getCreateMilestoneMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMilestone>>, TError,{launchId: number;data: BodyType<MilestoneInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createMilestone>>, TError,{launchId: number;data: BodyType<MilestoneInput>}, TContext> => {

const mutationKey = ['createMilestone'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMilestone>>, {launchId: number;data: BodyType<MilestoneInput>}> = (props) => {
          const {launchId,data} = props ?? {};

          return  createMilestone(launchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMilestoneMutationResult = NonNullable<Awaited<ReturnType<typeof createMilestone>>>
    export type CreateMilestoneMutationBody = BodyType<MilestoneInput>
    export type CreateMilestoneMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Create a milestone
 */
export const useCreateMilestone = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMilestone>>, TError,{launchId: number;data: BodyType<MilestoneInput>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createMilestone>>,
        TError,
        {launchId: number;data: BodyType<MilestoneInput>},
        TContext
      > => {
      return useMutation(getCreateMilestoneMutationOptions(options));
    }

export const getUpdateMilestoneUrl = (launchId: number,
    milestoneId: number,) => {




  return `/api/launchos/launches/${launchId}/milestones/${milestoneId}`
}

/**
 * @summary Update a milestone
 */
export const updateMilestone = async (launchId: number,
    milestoneId: number,
    milestoneUpdate: MilestoneUpdate, options?: RequestInit): Promise<Milestone> => {

  return customFetch<Milestone>(getUpdateMilestoneUrl(launchId,milestoneId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(milestoneUpdate)
  }
);}





export const getUpdateMilestoneMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMilestone>>, TError,{launchId: number;milestoneId: number;data: BodyType<MilestoneUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateMilestone>>, TError,{launchId: number;milestoneId: number;data: BodyType<MilestoneUpdate>}, TContext> => {

const mutationKey = ['updateMilestone'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMilestone>>, {launchId: number;milestoneId: number;data: BodyType<MilestoneUpdate>}> = (props) => {
          const {launchId,milestoneId,data} = props ?? {};

          return  updateMilestone(launchId,milestoneId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMilestoneMutationResult = NonNullable<Awaited<ReturnType<typeof updateMilestone>>>
    export type UpdateMilestoneMutationBody = BodyType<MilestoneUpdate>
    export type UpdateMilestoneMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update a milestone
 */
export const useUpdateMilestone = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMilestone>>, TError,{launchId: number;milestoneId: number;data: BodyType<MilestoneUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateMilestone>>,
        TError,
        {launchId: number;milestoneId: number;data: BodyType<MilestoneUpdate>},
        TContext
      > => {
      return useMutation(getUpdateMilestoneMutationOptions(options));
    }

export const getDeleteMilestoneUrl = (launchId: number,
    milestoneId: number,) => {




  return `/api/launchos/launches/${launchId}/milestones/${milestoneId}`
}

/**
 * @summary Delete a milestone
 */
export const deleteMilestone = async (launchId: number,
    milestoneId: number, options?: RequestInit): Promise<DeleteResponse> => {

  return customFetch<DeleteResponse>(getDeleteMilestoneUrl(launchId,milestoneId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteMilestoneMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMilestone>>, TError,{launchId: number;milestoneId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMilestone>>, TError,{launchId: number;milestoneId: number}, TContext> => {

const mutationKey = ['deleteMilestone'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMilestone>>, {launchId: number;milestoneId: number}> = (props) => {
          const {launchId,milestoneId} = props ?? {};

          return  deleteMilestone(launchId,milestoneId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteMilestoneMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMilestone>>>

    export type DeleteMilestoneMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete a milestone
 */
export const useDeleteMilestone = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMilestone>>, TError,{launchId: number;milestoneId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteMilestone>>,
        TError,
        {launchId: number;milestoneId: number},
        TContext
      > => {
      return useMutation(getDeleteMilestoneMutationOptions(options));
    }

export const getListAiOutputsUrl = (launchId: number,) => {




  return `/api/launchos/launches/${launchId}/ai-outputs`
}

/**
 * @summary List saved AI outputs for a launch
 */
export const listAiOutputs = async (launchId: number, options?: RequestInit): Promise<AiOutput[]> => {

  return customFetch<AiOutput[]>(getListAiOutputsUrl(launchId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAiOutputsQueryKey = (launchId: number,) => {
    return [
    `/api/launchos/launches/${launchId}/ai-outputs`
    ] as const;
    }


export const getListAiOutputsQueryOptions = <TData = Awaited<ReturnType<typeof listAiOutputs>>, TError = ErrorType<ErrorResponse>>(launchId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAiOutputs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAiOutputsQueryKey(launchId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiOutputs>>> = ({ signal }) => listAiOutputs(launchId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: launchId !== null && launchId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiOutputs>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAiOutputsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiOutputs>>>
export type ListAiOutputsQueryError = ErrorType<ErrorResponse>


/**
 * @summary List saved AI outputs for a launch
 */

export function useListAiOutputs<TData = Awaited<ReturnType<typeof listAiOutputs>>, TError = ErrorType<ErrorResponse>>(
 launchId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAiOutputs>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAiOutputsQueryOptions(launchId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGenerateAiOutputUrl = (launchId: number,) => {




  return `/api/launchos/launches/${launchId}/ai-outputs`
}

/**
 * @summary Generate and save an AI output
 */
export const generateAiOutput = async (launchId: number,
    aiOutputRequest: AiOutputRequest, options?: RequestInit): Promise<AiOutput> => {

  return customFetch<AiOutput>(getGenerateAiOutputUrl(launchId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(aiOutputRequest)
  }
);}





export const getGenerateAiOutputMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateAiOutput>>, TError,{launchId: number;data: BodyType<AiOutputRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof generateAiOutput>>, TError,{launchId: number;data: BodyType<AiOutputRequest>}, TContext> => {

const mutationKey = ['generateAiOutput'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateAiOutput>>, {launchId: number;data: BodyType<AiOutputRequest>}> = (props) => {
          const {launchId,data} = props ?? {};

          return  generateAiOutput(launchId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GenerateAiOutputMutationResult = NonNullable<Awaited<ReturnType<typeof generateAiOutput>>>
    export type GenerateAiOutputMutationBody = BodyType<AiOutputRequest>
    export type GenerateAiOutputMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Generate and save an AI output
 */
export const useGenerateAiOutput = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateAiOutput>>, TError,{launchId: number;data: BodyType<AiOutputRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof generateAiOutput>>,
        TError,
        {launchId: number;data: BodyType<AiOutputRequest>},
        TContext
      > => {
      return useMutation(getGenerateAiOutputMutationOptions(options));
    }

export const getGetAiOutputUrl = (launchId: number,
    outputId: number,) => {




  return `/api/launchos/launches/${launchId}/ai-outputs/${outputId}`
}

/**
 * @summary Get a specific AI output
 */
export const getAiOutput = async (launchId: number,
    outputId: number, options?: RequestInit): Promise<AiOutput> => {

  return customFetch<AiOutput>(getGetAiOutputUrl(launchId,outputId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAiOutputQueryKey = (launchId: number,
    outputId: number,) => {
    return [
    `/api/launchos/launches/${launchId}/ai-outputs/${outputId}`
    ] as const;
    }


export const getGetAiOutputQueryOptions = <TData = Awaited<ReturnType<typeof getAiOutput>>, TError = ErrorType<ErrorResponse>>(launchId: number,
    outputId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAiOutput>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAiOutputQueryKey(launchId,outputId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiOutput>>> = ({ signal }) => getAiOutput(launchId,outputId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: launchId !== null && launchId !== undefined && outputId !== null && outputId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiOutput>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAiOutputQueryResult = NonNullable<Awaited<ReturnType<typeof getAiOutput>>>
export type GetAiOutputQueryError = ErrorType<ErrorResponse>


/**
 * @summary Get a specific AI output
 */

export function useGetAiOutput<TData = Awaited<ReturnType<typeof getAiOutput>>, TError = ErrorType<ErrorResponse>>(
 launchId: number,
    outputId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAiOutput>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAiOutputQueryOptions(launchId,outputId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getUpdateAiOutputUrl = (launchId: number,
    outputId: number,) => {




  return `/api/launchos/launches/${launchId}/ai-outputs/${outputId}`
}

/**
 * @summary Update AI output label or status
 */
export const updateAiOutput = async (launchId: number,
    outputId: number,
    aiOutputUpdate: AiOutputUpdate, options?: RequestInit): Promise<AiOutput> => {

  return customFetch<AiOutput>(getUpdateAiOutputUrl(launchId,outputId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(aiOutputUpdate)
  }
);}





export const getUpdateAiOutputMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiOutput>>, TError,{launchId: number;outputId: number;data: BodyType<AiOutputUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateAiOutput>>, TError,{launchId: number;outputId: number;data: BodyType<AiOutputUpdate>}, TContext> => {

const mutationKey = ['updateAiOutput'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAiOutput>>, {launchId: number;outputId: number;data: BodyType<AiOutputUpdate>}> = (props) => {
          const {launchId,outputId,data} = props ?? {};

          return  updateAiOutput(launchId,outputId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAiOutputMutationResult = NonNullable<Awaited<ReturnType<typeof updateAiOutput>>>
    export type UpdateAiOutputMutationBody = BodyType<AiOutputUpdate>
    export type UpdateAiOutputMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Update AI output label or status
 */
export const useUpdateAiOutput = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiOutput>>, TError,{launchId: number;outputId: number;data: BodyType<AiOutputUpdate>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateAiOutput>>,
        TError,
        {launchId: number;outputId: number;data: BodyType<AiOutputUpdate>},
        TContext
      > => {
      return useMutation(getUpdateAiOutputMutationOptions(options));
    }

export const getDeleteAiOutputUrl = (launchId: number,
    outputId: number,) => {




  return `/api/launchos/launches/${launchId}/ai-outputs/${outputId}`
}

/**
 * @summary Delete an AI output
 */
export const deleteAiOutput = async (launchId: number,
    outputId: number, options?: RequestInit): Promise<DeleteResponse> => {

  return customFetch<DeleteResponse>(getDeleteAiOutputUrl(launchId,outputId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteAiOutputMutationOptions = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiOutput>>, TError,{launchId: number;outputId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiOutput>>, TError,{launchId: number;outputId: number}, TContext> => {

const mutationKey = ['deleteAiOutput'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiOutput>>, {launchId: number;outputId: number}> = (props) => {
          const {launchId,outputId} = props ?? {};

          return  deleteAiOutput(launchId,outputId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiOutputMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiOutput>>>

    export type DeleteAiOutputMutationError = ErrorType<ErrorResponse>

    /**
 * @summary Delete an AI output
 */
export const useDeleteAiOutput = <TError = ErrorType<ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiOutput>>, TError,{launchId: number;outputId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAiOutput>>,
        TError,
        {launchId: number;outputId: number},
        TContext
      > => {
      return useMutation(getDeleteAiOutputMutationOptions(options));
    }

